<div>
  <label *ngIf="titulo" id="labelDropId" for="opciones">{{titulo}}</label>
  <br *ngIf="titulo"/>

  <div [ngClass]="{'horizontal-container': tituloHorizontal}">
    <label *ngIf="tituloHorizontal" id="labelDropId" for="opciones">{{tituloHorizontal}}</label>

    <div *ngIf="conId" class="custom-select" [style.width]="width">
      <div tabindex="0" class="select-box" (mousedown)="toggleDropdown(); $event.preventDefault(); $event.stopPropagation()" [style.height]="height" [style.border]="borderStyle" [ngClass]="errorClass">
        {{ valorSeleccionadoDesc || placeholder}}
      </div>
      <ul *ngIf="dropdownOpen" class="options">
        <div class="scroll-container">
          <li *ngFor="let opcion of dataAsDesplegableData" (mousedown)="selectOption(opcion); $event.preventDefault(); $event.stopPropagation()">
            {{ opcion.desc }}
          </li>
        </div>
      </ul>
    </div>

    <div *ngIf="!conId" class="custom-select" [style.width]="width">
      <div tabindex="0" class="select-box" (mousedown)="toggleDropdown && toggleDropdown(); $event.preventDefault(); $event.stopPropagation()" [style.height]="height" [style.border]="borderStyle" [ngClass]="errorClass">
        {{ valorSeleccionado || placeholder }}
      </div>
      <ul *ngIf="dropdownOpen" class="options">
        <div class="scroll-container">
          <li *ngFor="let opcion of dataAsString" (mousedown)="selectOption(opcion); $event.preventDefault(); $event.stopPropagation()">
            {{ opcion }}
          </li>
        </div>
      </ul>
    </div>
  </div>
</div>
